import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "전문적",
  icon: "💼",
  templates: [
    {
      title: "YouTube / 영상 스크립트",
      content: `한 명의 내레이터가 설명하는 YouTube 영상 스크립트를 작성해 주세요.
- 영상 주제는 [재택근무 시 흔히 하는 5가지 실수 — 그리고 고치는 방법]입니다.
- 타깃 시청자: [첫 원격 근무를 시작하는 젊은 직장인].
- 톤: [친근하고, 대화적이며, 실용적 — 신뢰할 수 있는 동료의 조언처럼].
- 첫 두 문장에 강력한 훅, 요점 간 명확한 전환, 행동 촉구가 포함된 간결한 마무리로 구성해 주세요.
- 말하기용으로 작성해 주세요: 짧은 단락과 수사적 질문을 사용하여 청취자의 주의를 유지해 주세요.`
    },
    {
      title: "제품 설명",
      content: `제품 설명 영상의 내레이션 스크립트를 작성해 주세요.
- 제품은 [영수증을 스캔하여 지출을 추적하는 소규모 사업주용 모바일 앱]입니다.
- 타깃 시청자: [회계를 싫어하는 프리랜서와 소규모 사업주].
- 강조할 주요 이점:
  1. [2초 만에 영수증 스캔 — 수동 입력 불필요].
  2. [스마트 제안으로 자동 지출 분류].
  3. [세금 시즌을 위한 원탭 내보내기].
- 톤: [명확하고, 밝고, 안심을 주는 — 고통스러운 작업을 쉽게 만드는].
- 문장을 간결하고 임팩트 있게 유지해 주세요. 전문 용어를 피해 주세요.`
    },
    {
      title: "프레젠테이션 연설",
      content: `전문적인 프레젠테이션 또는 기조 연설을 작성해 주세요.
- 행사는 [새로운 분기를 시작하는 전사 미팅]입니다.
- 연설자는 [엔지니어, 디자이너, 매니저가 섞인 청중에게 말하는 팀 리더]입니다.
- 핵심 메시지: [지난 분기의 성과를 축하하고, 도전을 솔직하게 인정하며, 앞으로 몇 달간의 명확한 초점 아래 팀을 결집시키는 것].
- 톤: [자신감 있고, 진실하며, 동기를 부여하는 — 공허한 기업 용어가 아닌].
- 예상 발표 시간: [4분].
- 대화적인 표현, 전략적인 쉼, 기억에 남는 마무리 문장을 사용해 주세요.`
    }
  ]
};
